import { AxiosBookings, orgId } from "../apiConfig";
import { appendQueryParams } from "../../utilities/urlUtils";

export const dispatchApiFactory = {
    $_getDispatches(params) {
        const url = `/dispatch/all/${orgId()}${appendQueryParams(params)}`;
        return AxiosBookings.get(url);
    },
    $_searchDispatches(params){
        const url = `/dispatch/search/${orgId()}${appendQueryParams(params)}`;
        return AxiosBookings.get(url);
      },

    $_modifyDispatch(dispatchId, payload) {
        const url = `/dispatch/${dispatchId}`;
        return AxiosBookings.patch(url, payload);
    },

    $_cancelDispatch(dispatchId) {
        const url = `/dispatch/delete/${dispatchId}`;
        return AxiosBookings.delete(url);
    },

    $_getDispatch(id) {
        const url = `/dispatch/one/${id}`;
        return AxiosBookings.get(url);
      },

    $_getDispatchTimeline(dispatchId) {
        const url = `/dispatch/timeline/${dispatchId}`;
        return AxiosBookings.get(url);
    },
    $_acknowledgeDispatchRequest(payload) {
        const url = `/requests/acknowledge`;
        return AxiosBookings.patch(url, payload);
    },
    $_acknowledgeDispatchHandoff(payload) {
        const url = `requests/acknowledge-handoff`;
        return AxiosBookings.patch(url, payload);
    },
    $_getDispatchToplineAnalytics(){
        const url = `/dispatch/analytics/${orgId()}`;
        return AxiosBookings.get(url);
    }
};
